import type { DataConnectorSummary, ExtensionSummary } from '#layers/extensions/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const WorkspaceExtension = withItemType<ExtensionSummary>().defineCollection({
	name: 'WorkspaceExtension',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.id,
	meta: { endpoint: 'extensions' },
});

export const WorkspaceDataConnector = withItemType<DataConnectorSummary>().defineCollection({
	name: 'WorkspaceDataConnector',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.id,
	meta: { endpoint: 'connectors/data' },
});
